import {Issue} from "../domain/entities/issue.entity";
import {CommandName} from "./command-name.enum";
import {AbstractCommand} from "./abstract.command";

export class UpdateIssueCommand extends AbstractCommand<Issue> {

    public name: CommandName = CommandName.UPDATE_ISSUE;

    public tags = ['entity', 'change', 'issue'];

    constructor(payload: Issue) {
        super('issue', payload.uid, payload);
    }
}